import { useEffect, useState } from "react";
import { downloadAPK, listAppVersions } from "../../api";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";

const AppVersions = ({ locs, location, role }) => {
  const [appIds, setAppIds] = useState([]);
  const [isLoading, setIsLoading] = useState();

  useEffect(() => {
    if (role === "admin") {
      getAllAppIds();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: {
      versionType: "",
      loc: "",
    },
  });

  const getAllAppIds = async (data) => {
    try {
      setAppIds([]);
      setIsLoading(true);
      const versionLists = await listAppVersions({
        loc: role === "admin" ? location : data?.loc,
        app_id: "wmsplus-prod-apk",
      });
      if (versionLists?.data?.length) {
        setAppIds(versionLists?.data);
      } else {
        invokeToast(versionLists?.data?.message, "error");
      }
      setIsLoading(false);
    } catch (error) {
      invokeToast("Failed to get app list", "error");
      console.log(error);
    }
  };

  const onDownload = async (appId, version) => {
    try {
      const downloadUrl = await downloadAPK(
        appId,
        version,
        role === "admin" ? location : getValues("loc")
      );
      if (downloadUrl?.data?.url) {
        window.open(downloadUrl.data.url);
      } else {
        invokeToast(downloadUrl?.data?.message, downloadUrl?.data?.status);
      }
    } catch (error) {
      invokeToast("Failed to download apk", "error");
      console.log(error);
    }
  };

  const invokeToast = (msg, type) => {
    type === "success"
      ? toast.success(msg, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        })
      : toast.error(msg, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
  };

  return (
    <div>
      <div className="align-items-center app-table d-flex flex-column m-3">
        {(role === "wms_internal" && (
          <form className="w-25" onSubmit={handleSubmit(getAllAppIds)}>
            <div className="d-flex flex-column">
              <div className="d-flex align-items-baseline">
                <div className="header-text text-nowrap">
                  Select DC Location &nbsp;:&nbsp;
                </div>
                <select
                  {...register("loc", { required: true })}
                  className={[
                    "form-select role-select form-select-md",
                    errors.loc?.type === "required" && "border-red",
                  ].join(" ")}
                >
                  <option disabled value={""}>
                    Select Loc
                  </option>
                  {locs?.map((loc, i) => (
                    <option key={i} value={loc?.loc}>
                      {loc?.loc}
                    </option>
                  ))}
                </select>
              </div>
              {errors.loc?.type === "required" && (
                <div className="error-text ms-auto">Loc is required</div>
              )}
            </div>
            <div className="d-flex justify-content-center mt-4">
              <button className="btn btn-primary">Get Versions</button>
            </div>
          </form>
        )) ||
          ""}
        {(appIds?.length && (
          <>
            {(role === "wms_internal" && (
              <div className="border-bottom w-100 my-5 border-light"></div>
            )) ||
              ""}
            <table className="table">
              <thead>
                <tr>
                  <th>Version</th>
                  <th>Release Notes</th>
                  <th>Get APK</th>
                </tr>
              </thead>
              <tbody>
                {appIds?.map((app, i) => (
                  <tr key={i}>
                    <td>{app?.version}</td>
                    <td>{app?.release_notes}</td>
                    <td>
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          onDownload("wmsplus-prod-apk", app?.version)
                        }
                      >
                        Download
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {isLoading && (
              <div
                className="d-flex justify-content-center"
                style={{ marginTop: "5%" }}
              >
                <div className="lds-roller">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}
            {!appIds?.length && !isLoading && (
              <div className="d-flex justify-content-center w-100 no-records">
                No records found
              </div>
            )}
          </>
        )) ||
          ""}
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};
export default AppVersions;
